
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { NeedleReturnAfterProductionEntity } from './needle-return-after-production.entity';
import { NeedleReturnAfterProductionController } from './needle-return-after-production.controller';
import { NeedleReturnAfterProductionService } from './needle-return-after-production.service';
import { NeedleReturnProductionRepository } from './needle-return-after-production.repo';
import { StockOutEntity } from '../stock-in/entities/stock-out.entity';
import { StockOutRepository } from '../stock-in/repositories/stock-out.repository';
@Module({
  imports:[TypeOrmModule.forFeature([NeedleReturnAfterProductionEntity,StockOutEntity])],
  controllers: [NeedleReturnAfterProductionController],
  providers: [NeedleReturnAfterProductionService,NeedleReturnProductionRepository,StockOutRepository]
})
export class NeedleReturnProductionModule {}



